import App from './App';
import { createBrowserMonitoringAgent } from './browser-monitoring';
import './i18n';
import './index.scss';
import '@rpi/core-utils/dist/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';

createBrowserMonitoringAgent();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
